import type { IconDefinition } from '../shared/iconDefinition';
import { familyColorScale } from './familyColorScale';

const FALLBACK = '#7c869c';

function shiftLightness(hex: string, step: number): string {
  const value = hex.replace('#', '');
  const channels = [0, 2, 4].map((offset) => Number.parseInt(value.slice(offset, offset + 2), 16));
  const adjusted = channels.map((channel) => {
    const moved = channel + step * 26;
    return Math.max(0, Math.min(255, Math.round(moved)));
  });
  return `#${adjusted.map((channel) => channel.toString(16).padStart(2, '0')).join('')}`;
}

// Per-icon colours for the dashboard's individual-icon view.
//
// Derived from the family colour rather than picked independently, so switching
// the toggle from family to icon view reads as the same chart at higher
// resolution — which is what it is (DESIGN-DECISIONS §4, "collect wide, display
// rolled up"). Independent hues would make the two views look like different
// datasets and quietly break the comparison the toggle exists to support.
export function iconColorScale(icons: IconDefinition[]): Record<string, string> {
  const seenInFamily = new Map<string, number>();
  const scale: Record<string, string> = {};

  for (const icon of icons) {
    const base = familyColorScale[icon.family] ?? FALLBACK;
    const index = seenInFamily.get(icon.family) ?? 0;
    seenInFamily.set(icon.family, index + 1);
    // Centre the spread on the family colour so no single icon owns it.
    scale[icon.id] = shiftLightness(base, index - 1);
  }

  return scale;
}
